import { useRequest } from 'ahooks'
import { getEnvManagementList, startStopEnvManagement } from '@/api/client'
import { Message } from '@/components'
import { t } from '@/i18n'

export const useGetEnvManagementList = () => {
  const { runAsync: run, loading } = useRequest(
    (agentId: string) => getEnvManagementList(agentId),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取验证环境管理列表失败'))
      },
    },
  )

  return [run, loading] as const
}

export const useStartStopEnvManagement = () => {
  const { runAsync: run, loading } = useRequest(
    (agentId: string, dependencyId: string, isAutoStart: boolean) =>
      startStopEnvManagement(agentId, dependencyId, isAutoStart),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('启停客户端验证环境失败'))
      },
    },
  )

  return [run, loading] as const
}
